import { getData , putData } from './index';

import {
  GET_PAGE,
  UPDATE_PAGE,
  ERROR_PAGE,
  SAVE_PAGE,
  GET_SEO,
  UPDATE_SEO
} from "./types"


export async function getPageAction(dispatch , themeId , page , lang ) {
  let url = `/theme/company/${themeId}/${page}/${lang}`
  var theme;

  await getData(ERROR_PAGE, url, dispatch , true ).then((response)=>{
    theme = response
  });

  dispatch({
    type : GET_PAGE,
    payload : theme
  });

}

export async function updatePageAction(dispatch , themeId , site , page , param ) {
  let url = `/theme/${site}/${themeId}/`
  var theme;

  await putData(UPDATE_PAGE, ERROR_PAGE ,  url, dispatch, param , true ).then((response)=>{
    theme = response.theme[page]
  });

  dispatch({
    type : UPDATE_PAGE,
    payload : theme
  });
}

export async function getSeoAction(dispatch, companyId, lang) {
  let url = `/theme/company/${companyId}/seo/${lang}`;
  var seo;
  await getData(ERROR_PAGE, url, dispatch, true).then((response) => {
    seo = response;
  });
  dispatch({
    type: GET_SEO,
    payload: seo
  });
}

export async function updateSeoAction(dispatch, themeId, site, param) {
  let url = `/theme/${site}/${themeId}/`;
  var theme;
  await putData(UPDATE_SEO, ERROR_PAGE, url, dispatch, param, true).then((response) => {
    theme = response;
  });
  dispatch({
    type: UPDATE_SEO,
    payload: theme
  });
}

export async function savePageAction(dispatch , themeId , site , page , param ) {
  let url = `/theme/${site}/${themeId}/`
  var theme;

  await putData(UPDATE_PAGE, ERROR_PAGE ,  url, dispatch, param , true ).then((response)=>{
    theme = response.theme[page]
  });

  dispatch({
    type : SAVE_PAGE,
    payload : theme
  });

}